export default "__VITE_ASSET__DblpLqoE__"